import React from 'react';
import Spinner from 'src/Components/Spinner';
import styles from '../ItemDetail/styles.module.scss';

const ItemDetailPlaceholder = () => /*#__PURE__*/React.createElement("div", {
  className: styles.container
}, /*#__PURE__*/React.createElement("div", {
  className: styles.detailContainer
}, /*#__PURE__*/React.createElement(Spinner, {
  className: styles.loading
})));

export default ItemDetailPlaceholder;